export default {
  setFilesList(state, payload) {
    state.filesList = payload.fileList;
  },
  setStatus(state, payload) {
    state.status = payload.status;
  },
  setFileLinkStatus(state, payload) {
    state.mailStatus = payload.mailStatus;
    state.respFileName = payload.respFileName;
  }
}